import { useContext } from 'react';

import { FeatureFlagsContext } from '../FeatureFlagsContextProvider';

export const useFeatureFlags = () => {
  const { flags, isLoading } = useContext(FeatureFlagsContext);

  return { isLoading, flags };
};
